import React from 'react'
import './noMedia.css'
import { withTranslation } from 'react-i18next'

const NoMedia = (props) => (
    <div className="nomedia-wrapper">
        <i className="fa fa-exclamation-triangle"/>
        <p>{props.t('visualizer:media.unavailable')}</p>
        <hr />
    </div>
)

export default withTranslation()(NoMedia)
